module.exports = __webpack_public_path__ + "img/PS_offerings.d1ed5cc4.png";